import { render } from "./ReleaseReview.vue?vue&type=template&id=30956b64&scoped=true"
import script from "./ReleaseReview.vue?vue&type=script&lang=js"
export * from "./ReleaseReview.vue?vue&type=script&lang=js"

import "./ReleaseReview.vue?vue&type=style&index=0&id=30956b64&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30956b64"]])

export default __exports__